import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Admins } from '../../models/admins.model';
import { HttpService } from '../../services/http.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-admin-list',
  templateUrl: './admin-admin-list.component.html',
  styleUrls: ['./admin-admin-list.component.scss']
})
export class AdminAdminListComponent implements OnInit {

  admins: Admins = new Admins({});
  isLoading: boolean = false;
  loadingForList: boolean = false;
  adminForm: FormGroup = new FormGroup({});
  adminList: any = [];
  currentAdmin: any;
  isEditing: boolean = false;
  
  constructor(private formBuilder: FormBuilder, private httpService: HttpService) {
    const data: any = localStorage.getItem('currentAdmin');
    this.currentAdmin = new Admins(JSON.parse(data));
  }

  ngOnInit(): void {
    this.initForm();
    this.isEditing = false;
    
    this.getAdminList();
  }

  initForm() {
    this.adminForm = this.formBuilder.group({
      name: [(this.admins.getName() != null) ? this.admins.getName() : '', Validators.required],
      email: [(this.admins.getEmail() != null) ? this.admins.getEmail() : '', [Validators.required, Validators.email]],
      profile_id: [(this.admins.getProfilesId() != null) ? this.admins.getProfilesId() : '', Validators.required],
    });
  }
  
  onSubmitForm() {
    const formValue = this.adminForm.value;
    formValue['password'] = '1234';

    this.isLoading = true;
    if (this.isEditing === false) {
      this.httpService.saveAdmin(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            this.isLoading = false;
            this.initForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Administrateur créé avec succès.',
            }).then(() => {
              location.reload();
            });
          }
        },
        (error) => {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      );
    } else {
      this.httpService.updateAdmin(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.setItem('currentAdmin', JSON.stringify(data));
            this.isLoading = false;
            this.initForm();
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Information mise à jour avec succès.',
            }).then(() => {
              location.reload();
            });
          }
        },
        (error) => {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      );
    }
  }
  
  editAdmin(admin: Admins) {
    this.isEditing = true;
    this.admins = admin;
    this.initForm();
  }

  lockUnlock(email: string, is_locked: string) {
    const formValue = this.adminForm.value;

    this.isLoading = true;
    this.httpService.lockUnlockAdmin(email, is_locked).subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          this.initForm();
          Swal.fire({
            icon: 'success',
            title: 'Excellent !',
            text: 'Opération effectuée avec succès.',
          }).then(() => {
            location.reload();
          });
        }
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }
  
  getAdminList() {
    this.loadingForList = true;
    this.httpService.getAllAdmin().subscribe(
      (response: any) => {
        if (response.status == "success") {
          let data = response.data;
          data.forEach((element: any) => {
            let admin = new Admins(element);
            this.adminList.push(admin);
          });

          this.loadingForList = false;
        }
      },
      (error) => {
        this.loadingForList = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

}
